/**
 * VÉRAULT Portal — Client Preview Context (Wave 26.8)
 *
 * When the advisor previews the client view, we mount the actual client
 * components inside `<ClientPortalPreview>` and install an axios
 * interceptor that rewrites `/client-portal/...` → `/advisor/preview/...`.
 *
 * Problem: links inside client components hardcode `/portal/client/...`
 * which navigates AWAY from the preview wrapper, losing the interceptor
 * (and producing 401s + "Couldn't load your itinerary").
 *
 * Solution: a tiny PreviewContext that exposes the URL base path. Client
 * components read it to build their navigation URLs.
 *
 * Outside of preview, the default base is `/portal/client` — same as
 * before. Inside the preview, it becomes
 * `/portal/advisor/journeys/{tripId}/client-preview`.
 */
import React, { createContext, useContext } from "react";

const PreviewContext = createContext({ isPreview: false, base: "/portal/client" });

export function PreviewProvider({ isPreview, base, children }) {
  return (
    <PreviewContext.Provider value={{ isPreview: !!isPreview, base }}>
      {children}
    </PreviewContext.Provider>
  );
}

export function usePreviewBase() {
  return useContext(PreviewContext);
}

/** Helper: prefix a relative path with the active base.
 *  Accepts "/trip/abc/itinerary" or "trip/abc/itinerary" — both fine.
 */
export function previewPath(relative, base) {
  const clean = relative.startsWith("/") ? relative.slice(1) : relative;
  return `${base}/${clean}`;
}
